import styled from "styled-components";
import MenuTab from "../components/MenuTab";
import { useMyContext } from "@/app/utils/MyContext";
import { MenuTab as MenuTabClass, RaceNo } from "@/app/utils/class/common/base";
import { setRacesDetailLoading, setRouting } from "@/app/utils/Common";
import { text_size } from "@/app/utils/MixinSize";
import { useLanguage } from "@/app/utils/LanguageContext";
import { useState } from "react";
import RenderTabPanel from "../components";
import { menuTabSet } from "@/app/utils/constant/menuTabSet";

import RacingInfo from "@/app/ui/RaceDetail/components/RacingInfo";
import { useLoading } from "@/app/utils/LoadingContext";

const Container = styled.div`
  width: 100%;
  padding: 0;
  background: rgba(225, 225, 225, 1);
`;
const Wrapper = styled.div`
  width: 100%;
  border-radius: 4px;
`;
const Header = styled.div`
  padding: 14px;
  width: 100%;
  height: 40px;
  border-radius: 4px 4px 0px 0px;
  background: #132b68;
  p {
    ${text_size(15)}
    font-weight: 400;
    line-height: 16px;
    color: white;
  }
`;

type propType = {
  menuData: any;
  meetings: IMeeting[];
  setRacesDetailLoading: (loading: boolean) => void;
  isLoadingRacesDetail: boolean;
};
const RaceDetail: React.FC<propType> = (props) => {
  const { isLoading } = useLoading();
  const { triggerLoading } = useLoading();
  const { state: lang } = useLanguage();
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const isLoadingMenuTab = globalConfig.OTHERS.ENABLE_LOADING_CONTEXT ? isLoading('menuTab') : myContextState.isLoadingRaces;

  const handleChangeTab = (tab: any) => {
    const newTab = new MenuTabClass(tab)
    if (newTab.isValid()) {
      const lastSegment = window.location.pathname.split('/').pop();
      if (encodeURIComponent(newTab.valueOf()) !== lastSegment) {
        setRacesDetailLoading(props.setRacesDetailLoading, newTab.toString(), true);
      }
      console.log('route 6', encodeURIComponent(newTab.valueOf()))
      //results page, click all button(raceNo=all), and click other tab page, set raceNo=defaultRaceNo
      if (!myContextState.selectedRaceNo.isValid(newTab)) {
        triggerLoading('race', newTab.toString());
        setRouting(`/${encodeURIComponent(newTab.valueOf())}`, { 'RaceNo': myContextState.defaultRaceNo?.toParams(), 'b_cid': '' }, myContextState);
        myContextDispatch({ type: "update", value: { menuTab: newTab, selectedRaceNo: myContextState.defaultRaceNo } });
      } else {
        triggerLoading('page');
        setRouting(`/${encodeURIComponent(newTab.valueOf())}`, { 'b_cid': '' }, myContextState);
        myContextDispatch({ type: "update", value: { menuTab: newTab } });
      }
    }
  };

  const handleSelectRace = (raceNo: number) => {
    if (raceNo != -1 && raceNo !== myContextState.selectedRaceNo.valueOf()) {
      setRacesDetailLoading(props.setRacesDetailLoading, myContextState.menuTab.toString(), true, true);
      triggerLoading('race', myContextState.menuTab.toString());
      //setSelectedRaceNo(raceNo);
      myContextDispatch({
        type: "update",
        value: { selectedRaceNo: new RaceNo(raceNo) },
      });
    }
  };
  console.log("RacingInfo", myContextState)

  return (
    <>
      <Container className={isLoadingMenuTab ? 'loading' : ''} >
        <Wrapper>  
          <MenuTab
            type="pc"
            menuData={props.menuData}
            onChange={handleChangeTab}
            setRacesDetailLoading={props.setRacesDetailLoading}
          />

          <RacingInfo
            type="pc"
            meetings={props.meetings}
            setRacesDetailLoading={props.setRacesDetailLoading}
            handleSelectRace={handleSelectRace}
          //raceSelectorData={raceSelectorData}
          />
          <RenderTabPanel
            type="pc"
            setRacesDetailLoading={props.setRacesDetailLoading}
            isLoadingRacesDetail={props.isLoadingRacesDetail}
            meetings={props.meetings}
          />
        </Wrapper>
      </Container>
    </>
  );
};

export default RaceDetail;
